interface IComponent {
	show():void;
	hide():void;
	render(state:boolean):void;
	destructor():void
}

export default class Component implements IComponent  {
	public element:HTMLElement;

	constructor() {}

	public show():void {
		throw new Error("This method must be redefined");
	}

	public hide():void {
		throw new Error("This method must be redefined");
	}

	public isActive():boolean {
		throw new Error("This method must be redefined");
	}

	public destructor():void {
		throw new Error("This method must be redefined");
	}

	public render(state:boolean) {
		if (state) {
			this.hide();
			document.body.appendChild(this.element);
			setTimeout(() => this.show(), 100);
		} else {
			this.hide();
			setTimeout(() => {
				try { document.body.removeChild(this.element) } 
				catch (e) { return }
			}, 500);
		}
	}
}